/**
 * Document Highlight Service
 * 
 * Centralized service for managing document highlighting across commands.
 */

export { DocumentHighlightService, documentHighlightService } from './DocumentHighlightService';
export type {
  HighlightSession,
  HighlightEvent,
  HighlightEventType,
  HighlightListener,
  HighlightConfig,
  ReviewProgressDetail
} from './types';
export { DEFAULT_CONFIG, REVIEW_PROGRESS_EVENT } from './constants';

